import React from 'react'
import styled from 'styled-components'

import { Box, Text } from '@usap/uicomponents'

export const Container = styled(Box)`
  width: 1000px;
  margin: 0 auto;
  padding: 8px;

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    padding: 16px;
  }
`

export const SubHeading = styled(Box)`
  display: none;
  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    display: flex;
  }
`

export const OrderSummaryMobile = styled(Box)`
  display: flex;
  padding: 0px;
  width: 100%;
  border-left: solid 1px transparent;
  order: ${props => props.orderMobile || props.order};

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    display: none;
  }
`

export const OrderSummaryMobileBox = styled(Box)`
  border: solid 1px #E0E0E0;
  padding: 6px;
`

export const OrderInformationBox = styled(Box)`
  flex-direction: column;
  margin-top: 8px;
  margin-bottom: 8px;
  border: none;
  order: 3;

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    border: solid 1px #E0E0E0;
    flex-direction: row;
    order: 2;
  }
`

export const InformationBox = styled(Box)`
  width: 100%;
  padding: 0px;
  order: ${props => props.orderMobile || props.order};

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    width: 33.33%;
    padding: 16px;
    order: ${props => props.order};
    ${props => (props.withBorder ? 'border-left: solid 1px #E0E0E0;' : '')}
  }
`

export const InformationTitleBox = styled(Box)`
  padding-top: 16px;
  padding-bottom: 16px;
 
  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    padding-top: 4px;
    padding-bottom: 4px;
  }
`

export const InformationBodyBox = styled(Box)`
  border: solid 1px #E0E0E0;
  padding: 6px;

  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    border: none;
    padding: 0px;
  }
`

export const OrdersContainer = styled(Box)`
  padding-top: 8px;
  padding-bottomm: 8px;
  order: 2;
  
  ${props => props.theme.mediaQuery.up('tablet-landscape')} {
    order: 3;
  }
`

export const ToolTipContainer = styled(Box)`
  position: relative;
  justify-content: space-between;
  flex-direction: row;
`

export const ToolTip = styled(Box)`
  align-items: center;
  justify-content: center;
  width: 276px;
  height: 102px;
  border: solid 1px #E0E0E0;
  background: #fff;
  position: absolute;
  left: 0;
  top: -110px;
  z-index: 9;
  border-radius: 4px;
  box-shadow: 1px 2px 5px 1px rgba(3, 3, 3, 0.2);
  max-width: unset;
`

export const ToolTipContent = styled(Text)`
  font-size: 12px;
  padding: 10px;
  line-height: 18px;
`

export const ToolTipArrow = styled(Box)`
  position: absolute;
  bottom: -22px;
  left: 46px;
`

export const SubTotalTipIcon = styled(Box)`
  position: absolute;
  left: 58px;
  cursor: pointer;
`
